<h3 class="popup-header">{{data.title}}</h3>
<mat-dialog-content class="mat-typography">
  <div fxLayoutGap="2%">
    <p class="innerHtml" [innerHtml]="sharedService.innerHtmlSanitizer(data.message)"></p>
  </div>
</mat-dialog-content>
<mat-dialog-actions class="popup-footer">
  <button *ngIf="extraButton?.isVisible" mat-raised-button color="primary" (click)="extraButtonClick()">
    <i class="fas fa-check"></i>{{extraButton?.name ? extraButton?.name : ''}}
  </button>

  <button mat-raised-button color="primary" (click)="conformOk()">
    <i class="fas fa-check"></i>{{data.ok ? data.ok : 'Ok'}}
  </button>
  <button mat-raised-button color="warn" (click)="onNoClick()">
    <i class="fas fa-times"></i>{{data.cancel ? data.cancel : 'Cancel'}}
  </button>
</mat-dialog-actions>